import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

const sizeClass = { md: 'text-base', lg: 'text-2xl' } as const;

export const Wordmark = ({
  to,
  onClick,
  size = 'md',
  className,
}: {
  to: string;
  onClick?: () => void;
  size?: keyof typeof sizeClass;
  className?: string;
}) => {
  const { t } = useTranslation();
  return (
    <Link
      to={to}
      onClick={onClick}
      className={[
        'inline-flex shrink-0 flex-col gap-1 font-semibold tracking-tight whitespace-nowrap text-content',
        sizeClass[size],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span>{t('app.name')}</span>
      <span aria-hidden="true" className="block h-0.5 w-7 bg-accent" />
    </Link>
  );
};
